import React, { useEffect } from 'react';
import { DialogUI } from '../Interface';
import ServicePage from './ServicePage';
import { useService } from '../../hooks/useService';

const ServiceDialog = ({ showDialog, onClose, data, changed }) => {
  const serviceState = useService();
  const { serviceChanged, setServiceChanged } = changed;

  useEffect(() => {
    if (data && !serviceState.loading) {
      serviceState.setSelectedValues(data);
    }
  }, [data, serviceState, serviceState.loading]);

  return (
    <DialogUI open={showDialog} headerContent={'Szerviz munkalap'} fullWidth={true} onClose={onClose} maxWidth="xl">
      <ServicePage
        dialog={{
          handleClose: onClose,
          serviceChanged: serviceChanged,
          setServiceChanged: setServiceChanged,
        }}
        serviceState={serviceState}
      />
    </DialogUI>
  );
};

export default ServiceDialog;
